"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.TagVariant = exports.TagSize = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../Styled/common");
var TagSize;
(function (TagSize) {
    TagSize["STANDARD"] = "standard";
    TagSize["SMALL"] = "small";
    TagSize["LARGE"] = "large";
    TagSize["FLOATINGLARGE"] = "floating-large";
})(TagSize = exports.TagSize || (exports.TagSize = {}));
var TagVariant;
(function (TagVariant) {
    TagVariant["PRIMARY"] = "primary";
    TagVariant["SECONDARY"] = "secondary";
    TagVariant["DEAL"] = "deal";
    TagVariant["POPULAR"] = "popular";
    TagVariant["INFORMATION"] = "information";
    TagVariant["ERROR"] = "error";
    TagVariant["INACTIVE"] = "inactive";
    TagVariant["ELEVATED"] = "elevated";
    TagVariant["TIME"] = "time";
    TagVariant["BESTINTHECITY"] = "best-in-the-city";
    TagVariant["SPONSORED"] = "sponsored";
    TagVariant["GRADIENT"] = "gradient";
    TagVariant["SUCCESS"] = "success";
})(TagVariant = exports.TagVariant || (exports.TagVariant = {}));
const Tag = (_a) => {
    var { id, className, label, size = TagSize.STANDARD, variant = TagVariant.PRIMARY, icon, secondaryLabel, secondaryIcon, secondaryDivider, margin, marginX, marginY, marginRight, marginLeft, marginTop, marginBottom } = _a, restProps = __rest(_a, ["id", "className", "label", "size", "variant", "icon", "secondaryLabel", "secondaryIcon", "secondaryDivider", "margin", "marginX", "marginY", "marginRight", "marginLeft", "marginTop", "marginBottom"]);
    const tagBaseClassName = 'bds-c-tag';
    const tagSizeClassName = classnames_1.default({
        [`${tagBaseClassName}--size-${size}`]: size
    });
    const tagVariantClassName = classnames_1.default({
        [`${tagBaseClassName}--variant-${variant}`]: variant
    });
    const tagMarginClassNames = common_1.mapMarginPropsToClassName({
        margin,
        marginX,
        marginY,
        marginRight,
        marginLeft,
        marginTop,
        marginBottom
    });
    const tagClassName = classnames_1.default(tagBaseClassName, tagSizeClassName, tagVariantClassName, tagMarginClassNames, className);
    return (react_1.default.createElement("div", Object.assign({ id: id, className: tagClassName }, restProps),
        icon ? icon : null,
        react_1.default.createElement("span", { className: `${tagBaseClassName}__label` }, label),
        secondaryLabel ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: `${tagBaseClassName}__secondary-divider` }, secondaryDivider ? secondaryDivider : '+'),
            secondaryIcon ? secondaryIcon : null,
            react_1.default.createElement("span", { className: `${tagBaseClassName}__secondary-label` }, secondaryLabel))) : null));
};
exports.Tag = Tag;
exports.default = exports.Tag;
